// @ts-nocheck
/* eslint-disable */
import { useLayoutEffect, useEffect } from 'react'
import { LOCAL_ENUM } from '@/constants'

export const getFallbackForLng = (lng: string, fallbackLng: any): string[] => {
  if (typeof fallbackLng === 'string') {
    return [fallbackLng]
  }

  if (Array.isArray(fallbackLng)) {
    return fallbackLng
  }

  if (typeof fallbackLng === 'object') {
    const fallbackList = (fallbackLng as any)[lng]
    const fallbackDefault = (fallbackLng as any).default
    return [...(fallbackList ?? []), ...(fallbackDefault ?? [])]
  }

  if (typeof fallbackLng === 'function') {
    return getFallbackForLng(lng, fallbackLng?.(lng))
  }

  return []
}

export const unique = (list: string[]) => Array.from(new Set<string>(list))

/**
 * 区分服务端与客户端的useEffect
 */
export const useIsomorphicLayoutEffect = typeof window !== 'undefined' ? useLayoutEffect : useEffect

/**
 * 请求头的lang
 * @param acceptLang
 * @returns
 */
export const getHeaderLang = (acceptLang: string) => {
  if (typeof acceptLang !== 'string') {
    return LOCAL_ENUM.ZH_CN
  }
  const [lang] = acceptLang.split(',')
  const curretLang = lang?.split(';')?.[0] || ''
  return curretLang?.includes('zh') ? LOCAL_ENUM.ZH_CN : LOCAL_ENUM.EN_US
}

/**
 * 动态翻译
 * @param content
 * @param values
 * @returns
 */
export const dynamicTrans = (content: string, values?: Record<string, any>) => {
  if (!content || typeof content !== 'string') {
    return content;
  }

  if (values && typeof values === 'object' && Object.keys(values).length > 0) {
    // 动态文本
    const regex = /{{\s*(.*?)\s*}}/g;
    const matches = [];
    let match;
    while ((match = regex.exec(content)) !== null) {
      matches.push(match[1]);
    }
    return content.replace(/{{\s*(.*?)\s*}}/g, (_, p1) => values[p1.trim()]);
  }

  return content;
};
